// removed by extract-text-webpack-plugin
module.exports = {"card":"src-components-CardWithButton----styles-module---card---6EXba","title":"src-components-CardWithButton----styles-module---title---3x8F5","button":"src-components-CardWithButton----styles-module---button---3M8hh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CardWithButton/styles.module.css
// module id = 496
// module chunks = 168707334958949